







import Vue from 'vue';
import Copyright from '@/components/Common/Copyright.vue';

export default Vue.extend({
    name: 'CopyrightPanel',
    components: {
        Copyright,
    },
});
